import { apiClient } from "../../../lib/api";
export const base = "/api/crm/sales-desk/";
export async function load<T>(path: string): Promise<T> {
  return (await apiClient.get<T>(path)).data;
}
export const money = (v: string | number | null) =>
  v === null
    ? "Not available"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(Number(v));
export const stamp = (v: string | null) =>
  v
    ? new Date(v).toLocaleString([], {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "Not set";
export const duration = (v: number | null) =>
  v === null
    ? "—"
    : v < 60
      ? `${Math.round(v)} min`
      : v < 1440
        ? `${(v / 60).toFixed(1)} hr`
        : `${(v / 1440).toFixed(1)} days`;
export const age = (v: string | null) =>
  v
    ? `${duration(Math.max(0, (Date.now() - new Date(v).getTime()) / 60000))} ago`
    : "No confirmed outreach";
export const stops = ["reply", "booking", "signature", "opt_out", "closed"];
export const stopLabel: Record<string, string> = {
  reply: "Customer reply",
  booking: "Inspection or meeting booked",
  signature: "Proposal or contract signed",
  opt_out: "Customer opts out",
  closed: "Opportunity closed",
};
